"use strict";

exports.__esModule = true;
exports.Observable = undefined;

var _typeof2 = require("babel-runtime/helpers/typeof");

var _typeof3 = _interopRequireDefault(_typeof2);

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Observable = exports.Observable = function () {
  function Observable(subscribeAction) {
    (0, _classCallCheck3["default"])(this, Observable);

    this.subscribeAction = subscribeAction;
  }

  Observable.prototype.subscribe = function subscribe(oOrOnNext, onError, onCompleted) {
    var observer = new Observer(oOrOnNext, onError, onCompleted);
    var result = this.subscribeAction(observer); // 开始发射数据并拿到subscribeAction的返回值
    return new Subscription(observer, result); // 创造控制observer和subscribeAction的实例对象
  };

  return Observable;
}();

var Observer = function () {
  function Observer(onNext, onError, onCompleted) {
    (0, _classCallCheck3["default"])(this, Observer);

    this.isStopped = false;
    if ((typeof onNext === "undefined" ? "undefined" : (0, _typeof3["default"])(onNext)) === "object") {
      this._onNext = onNext.next;
      this._onError = onNext.error;
      this._onCompleted = onNext.complete;
    } else {
      this._onNext = onNext;
      this._onError = onError;
      this._onCompleted = onCompleted;
    }
  }

  Observer.prototype.next = function next(value) {
    if (!this.isStopped && this._onNext) {
      this._onNext(value);
    }
  };

  Observer.prototype.error = function error(err) {
    if (!this.isStopped && this._onError) {
      this.isStopped = true;
      this._onError(err);
    }
  };

  Observer.prototype.complete = function complete(res) {
    if (!this.isStopped && this._onCompleted) {
      this.isStopped = true;
      this._onCompleted(res);
    }
  };

  return Observer;
}();

var Subscription = function () {
  function Subscription(observer, result) {
    (0, _classCallCheck3["default"])(this, Subscription);

    this.observer = observer;
    this.result = result;
  }

  Subscription.prototype.unsubscribe = function unsubscribe() {
    this.observer.isStopped = true; // 取消observer的订阅
    this.result();
  };

  return Subscription;
}();


//////////////////
// WEBPACK FOOTER
// ./src/observable.js
// module id = 94
// module chunks = 0